module.exports = __webpack_public_path__ + "../resources/img/img_error.c35abc47.svg";